import { mainApi } from "../../../../api";

export const childrenSubscriptionsQuery = (isEnabled?: boolean) => ({
    queryKey: ["childrenSubscriptions"],
    queryFn: async () => mainApi.get("get_children_and_subscriptions"),
    enabled: isEnabled,
});
